<template>
  <section>
        <template>
          <div class="row">
            <div class="col-12">
              <strong class="py-2">
                <span>{{ item.label }}</span>
                 </strong>
                 <div>

                <Fieldset title="Prompt" class="my-2" :mykey="Number(item.id)">
                 {{item.ask}}
                 </Fieldset>
                <span v-if="!editing" >
                  <span class="text-primary mr-1 border-bottom-1 border-style-dashed border-right-0  border-left-0 border-top-0" v-if="item.answer"> {{ item.answer }} </span>
                  <span class="text-secondary mx-1" v-else>_ _ _<i @click="open" class="icon-pencil text-primary cursor-pointer"></i></span>
                </span>
                <input v-if="editing" class="border-secondary border-style-dashed text-primary border-right-0  border-left-0 border-top-0 border-bottom-1  pt-0 col-10"
                  type="text" v-model="item.answer"/>

              <button  v-if="!editing" @click="open" class="btn  rounded-circle  cursor-pointer btn-sm btn-primary" type="button">
                <i class="icon-pencil"></i>
              </button>

              <button v-if="editing" @click="save" class="btn rounded-circle  cursor-pointer btn-sm btn-success" type="button">
                <i class="icon-check1"></i>
              </button>

              </div>



            </div>
          </div>
        </template>

  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Fieldset from "@/components/Common/Fieldset.vue";


export default {
  data() {
    return {
      editing: false
      }
  },
  props: {
    item: false
  },
  components: {
    Fieldset
  },

   methods: {

    save(){
      this.editing=false
      this.item.verified = '1';
      this.$emit("save",this.item)
    },
    open(){
      this.answer = this.item.answer
      this.editing=true
    },
    updateText(e) {
    },
  }
  }
</script>
<style>
.border-style-dashed{
  border-style: dashed;
  border:1px dashed;

}
</style>
